/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import Row from "../../../common/core/Row";
import Col from "../../../common/core/Col";
import Button from "../../../common/core/Button";
import Input from "../../../common/core/Input";
import Label from "../../../common/core/Label";
import Modal from "../../../common/core/Modal";
import ModalHeader from "../../../common/core/ModalHeader";
import ModalBody from "../../../common/core/ModalBody";
import ModalFooter from "../../../common/core/ModalFooter";
import Form from "../../../common/core/Form";
import FormGroup from "../../../common/core/FormGroup";
import FormFeedback from "../../../common/core/FormFeedback";
import Alert from "../../../common/core/Alert";
import ValidationConstants from "../../../common/utils/validationConstants";
import Spinner from "../../../common/core/Spinner";

const AddSeason = (props) => {
  const {
    addModal,
    toggleAddModal,
    handleCloseAddModal,
    season,
    handleChange,
    submitSeasonForm,
    handleSubmit,
    register,
    errors,
    handleDateChange,
    message,
    addSeasonInProgress,
  } = props;

  const {
    IS_SEASON_ID, IS_SEASON_NAME, IS_COUNTRY_ID,
  } = ValidationConstants;

  return (
    <>
      <Modal isOpen={addModal} toggle={() => toggleAddModal()} centered backdrop="static">
        <ModalHeader toggle={handleCloseAddModal}>
          Add Season
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(submitSeasonForm)}>
            {addSeasonInProgress
              ? (
                <div className="d-flex align-items-center justify-content-center">
                  <Spinner />
                </div>
              )
              : (
                <>
                  {
                    message && message.type === "warning" && (
                      <Alert color={message.type}>
                        {message.message}
                      </Alert>
                    )
                  }
                </>
              )}
            <fieldset disabled={addSeasonInProgress}>
              <div className="edit-block last mb-2">
                <Col md="12" className="edit-item mb-3">
                  <FormGroup>
                    <Label for="" className="me-sm-2">Season ID *</Label>
                    <Input
                      type="text"
                      name="seasonId"
                      id=""
                      defaultValue={season.seasonId}
                      onChange={handleChange}
                      innerRef={register({
                        pattern: {
                          value: IS_SEASON_ID,
                          message: "Invalid Season Id",
                        },
                      })}
                      invalid={errors.seasonId && errors.seasonId.message}
                      required
                    />
                    <FormFeedback>
                      {errors.seasonId && errors.seasonId.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="12" className="edit-item mb-3">
                  <FormGroup>
                    <Label for="" className="me-sm-2">Season Name *</Label>
                    <Input
                      type="text"
                      name="seasonName"
                      id=""
                      defaultValue={season.seasonName}
                      onChange={handleChange}
                      innerRef={register({
                        pattern: {
                          value: IS_SEASON_NAME,
                          message: "Invalid Season Name",
                        },
                      })}
                      invalid={errors.seasonName && errors.seasonName.message}
                      required
                    />
                    <FormFeedback>
                      {errors.seasonName && errors.seasonName.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="12" className="edit-item mb-3">
                  <FormGroup>
                    <Label for="" className="me-sm-2">Season Group *</Label>
                    <Input
                      type="text"
                      name="seasonGroup"
                      id=""
                      defaultValue={season.seasonGroup}
                      onChange={handleChange}
                      innerRef={register({
                        pattern: {
                          value: IS_SEASON_NAME,
                          message: "Invalid Season Group",
                        },
                      })}
                      invalid={errors.seasonGroup && errors.seasonGroup.message}
                      required
                    />
                    <FormFeedback>
                      {errors.seasonGroup && errors.seasonGroup.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="12" className="edit-item mb-3">
                  <FormGroup>
                    <Label for="" className="me-sm-2">Country ID</Label>
                    <Input
                      type="text"
                      name="countryId"
                      id=""
                      defaultValue={season.countryId}
                      onChange={handleChange}
                      innerRef={register({
                        pattern: {
                          value: IS_COUNTRY_ID,
                          message: "Invalid Country Id",
                        },
                      })}
                      invalid={errors.countryId && errors.countryId.message}
                    />
                    <FormFeedback>
                      {errors.countryId && errors.countryId.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Row>
                  <Col md="6" className="edit-item">
                    <FormGroup>
                      <Label for="" className="me-sm-2">Start Date</Label>
                      <Datetime
                        id="startDate"
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        closeOnSelect
                        input
                        inputProps={{
                          placeholder: `Ex: ${moment().format("DD/MM/YYYY")}`,
                          name: "startDate",
                        }}
                        name="startDate"
                        onChange={(o) => (moment.isMoment(o) && handleDateChange("startDate", o))}
                        value={moment(season.startDate).format("DD-MM-YYYY")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="edit-item">
                    <FormGroup>
                      <Label for="" className="me-sm-2">End Date</Label>
                      <Datetime
                        id="endDate"
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        closeOnSelect
                        input
                        name="endDate"
                        onChange={(o) => (moment.isMoment(o) && handleDateChange("endDate", o))}
                        value={moment(season.endDate).format("DD-MM-YYYY")}
                        isValidDate={(current) => current.isSameOrAfter(moment(season.startDate).startOf("day"))}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <ModalFooter>
                <Button color="primary" className="btn-radius">
                  Save
                </Button>
                <Button color="light" className="btn-radius" onClick={handleCloseAddModal}>Cancel</Button>
              </ModalFooter>
            </fieldset>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

AddSeason.propTypes = {
  addModal: PropTypes.bool.isRequired,
  toggleAddModal: PropTypes.func.isRequired,
  handleCloseAddModal: PropTypes.func.isRequired,
  season: PropTypes.objectOf(PropTypes.any).isRequired,
  handleChange: PropTypes.func.isRequired,
  submitSeasonForm: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  handleDateChange: PropTypes.func.isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  addSeasonInProgress: PropTypes.bool.isRequired,
};
export default AddSeason;
